import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, Subscription, catchError, filter, interval, of, switchMap, take, tap } from 'rxjs';
import { environment } from '../../environments/environment.dev';

@Injectable({ providedIn: 'root' })
export class HealthCheckService {
    private maintenanceSubject = new BehaviorSubject<boolean>(false);
    public maintenance$ = this.maintenanceSubject.asObservable();
    private url = environment.apiUrl + '/healthcheck/';
    private maintenancePollingSub: Subscription | null = null;
    public onlineSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(navigator.onLine);


    constructor(private http: HttpClient) { }

    checkHealth() {
        return this.http.get(this.url).pipe(
            tap(() => {
                this.maintenanceSubject.next(false);
            }),
            catchError((_err) => {
                this.maintenanceSubject.next(true);
                return of(null);
            })
        );
    }

    setMaintenanceMode(val: boolean) {
        this.maintenanceSubject.next(val);
        if (val) {
            this.startMaintenancePolling();
        } else {
            this.stopMaintenancePolling();
        }
    }

    private startMaintenancePolling() {
        if (this.maintenancePollingSub) return;
        this.maintenancePollingSub = interval(15000).pipe(
            switchMap(() => this.checkHealth())
        ).subscribe();
    }

    private stopMaintenancePolling() {
        if (this.maintenancePollingSub) {
            this.maintenancePollingSub.unsubscribe();
            this.maintenancePollingSub = null;
        }
    }

    waitForHealthy() {
        return this.maintenance$.pipe(
            filter(isMaint => !isMaint),
            take(1)
        );
    }

    public get isOnline$(): Observable<boolean> {
        return this.onlineSubject.asObservable();
    }
} 